// Web-Push im Browser: Abo anlegen/aufheben (Service Worker aus vite-plugin-pwa, Push-Teil in public/push-sw.js)
import { api } from './api.ts';

export function pushMoeglich() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

function urlBase64ToUint8Array(s: string) {
  const padding = '='.repeat((4 - (s.length % 4)) % 4);
  const b64 = (s + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(b64);
  return Uint8Array.from([...raw].map((ch) => ch.charCodeAt(0)));
}

export async function pushStatus(): Promise<{
  verfuegbar: boolean;
  erlaubnis: NotificationPermission | 'n/a';
  aktiv: boolean;
}> {
  if (!pushMoeglich()) return { verfuegbar: false, erlaubnis: 'n/a', aktiv: false };
  const { publicKey, abos } = await api.pushVapid();
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  return {
    verfuegbar: !!publicKey,
    erlaubnis: Notification.permission,
    aktiv: !!sub && abos.includes(sub.endpoint),
  };
}

export async function pushAn(): Promise<void> {
  const { publicKey } = await api.pushVapid();
  if (!publicKey) throw new Error('Push ist auf dem Server nicht eingerichtet (VAPID-Schlüssel).');
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Benachrichtigungen wurden nicht erlaubt.');
  const reg = await navigator.serviceWorker.ready;
  const sub =
    (await reg.pushManager.getSubscription()) ??
    (await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    }));
  const j = sub.toJSON();
  await api.pushSubscribe({
    endpoint: sub.endpoint,
    keys: { p256dh: j.keys?.['p256dh'] ?? '', auth: j.keys?.['auth'] ?? '' },
    userAgent: navigator.userAgent.slice(0, 300),
  });
}

export async function pushAus(): Promise<void> {
  const reg = await navigator.serviceWorker.getRegistration();
  const sub = await reg?.pushManager.getSubscription();
  if (sub) {
    await api.pushUnsubscribe(sub.endpoint);
    await sub.unsubscribe();
  }
}
